import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#44403c",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.67",
      d: "M8.557 17.5a1.667 1.667 0 0 0 2.886 0M2.718 12.772a.833.833 0 0 0 .615 1.395h13.334a.834.834 0 0 0 .616-1.394C16.175 11.63 15 10.416 15 6.667a5 5 0 0 0-10 0c0 3.749-1.176 4.963-2.282 6.105"
    }, null, -1)
  ]))]))
}
export default { render: render }